// #region Import
//Vue
import { createApp } from 'vue';
//Styles
import "./styles/_main.scss";
//Local
import Utils from "./shared/utils";
import ThePortal from './PortalHost';
import clickOutside from "./directives/click-outside";
import tooltip from "./directives/tooltip";
// #endregion
// #region Utils
//New
const tUtils = new Utils();
//set
global.utils = tUtils;
window.utils = tUtils;
// #endregion
// #region App
//App
const app = createApp({
    template: '<g-app />'
});
const tPortal = new ThePortal(app);
// #endregion
// #region Global-Properties
app.config.globalProperties.$utils = tUtils;
app.config.globalProperties.$device = tUtils.device;
app.config.globalProperties.$host = tPortal;
app.config.globalProperties.$store = tPortal.store;
window.host = tPortal;
// #endregion
// #region Register
//System
host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
host.store.registerAll(require.context('./stores', true, /(?<!views)\.ts$/));
host.actions.registerAll(require.context('./actions', true, /(?<!modules)\.ts$/));
//Directives
app.directive("click-outside", clickOutside);
app.directive("tooltip", tooltip);
// #endregion
